import { Input } from '@/components/ui/Input/Input';

/**
 * Форматирует ввод в "HH:mm": только цифры, ":" подставляется после двух цифр (как в ячейке времени).
 * Пустое значение и стирание часов допускаются.
 */
function formatTimeValue(input: string): string {
  const digits = input.replace(/\D/g, '').slice(0, 4);
  if (digits.length === 0) return '';
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}:${digits.slice(2)}`;
}

export interface TimeInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  'aria-label'?: string;
  id?: string;
}

export function TimeInput({ value, onChange, label, placeholder = '09:00', id, ...aria }: TimeInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = formatTimeValue(e.target.value);
    onChange(next);
  };

  return (
    <Input
      id={id}
      label={label}
      type="text"
      inputMode="numeric"
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      maxLength={5}
      aria-label={aria['aria-label']}
    />
  );
}
